<template>
    <label 
        class="inline-flex items-center gap-1.5 select-none"
        :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'">
        <input
            type="checkbox"
            class="peer sr-only"
            :id="id"
            :checked="modelValue"
            :disabled="disabled"
            :true-value="trueValue"
            :false-value="falseValue"
            @change="$emit('update:modelValue', $event.target.checked ? trueValue : falseValue)"
        />
        <!-- After : disabled면 회색 우선 적용 -->
        <span 
            class="flex-shrink-0  flex items-center justify-center w-4 h-4 rounded-01 border transition-colors"
            :class="[
                disabled ? 'bg-gray-400 border-gray-500 opacity-60 cursor-not-allowed'
                    : checked ? 'bg-primary-3 border-primary-3' : 'bg-white border-border-basic-2'
            ]"
        >
            <svg v-if="checked" mlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
                <path d="M3.49693 7L0 3.68191L0.874233 2.85239L3.49693 5.34096L9.12577 0L10 0.829522L3.49693 7Z" fill="white"/>
            </svg>
        </span>
        <span
            class="text-base "
            :class="disabled ? 'text-content-basic-2' : checked ? 'text-primary-3' : 'text-content-basic-2'">{{ label }}</span>
    </label>
</template>

<script>
export default {
    name: 'design-checkbox',
    components : {
    },
    props: {
        modelValue: {
            type: [Boolean, String],
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        trueValue : { type : [String, Boolean], default : true },
        falseValue : { type : [String, Boolean], default : false }
    },
    emits: ['update:modelValue'],
    computed : {
        checked(){
            return this.modelValue == this.trueValue;
        }
    },
    methods: {
        toggle() {
            if (this.disabled) return;
            this.$emit('update:modelValue', this.modelValue);
        },
    },
};
</script>
